// extracted by mini-css-extract-plugin
module.exports = {"exploration":"extra-info_exploration__pH8LG","greyWrapper":"extra-info_greyWrapper__fsDAQ","messageForCompany":"extra-info_messageForCompany__FC28K","row":"extra-info_row__RWaYP"};